import React from 'react';
import { Modal } from '../common/Modal';
import { Button } from '../common/Button';
import { HighlightedText } from '../common/HighlightedText';
import { speak, isSpeechSupported } from '../../utils/speak';

/**
 * Read-only modal displaying full word details
 * Shows word, translation, examples, and learning level
 */
export const WordDetailsModal = ({ isOpen, onClose, word }) => {
  if (!word) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title={
        <span className="flex items-center gap-2">
          {word.word}
          {isSpeechSupported() && (
            <button
              onClick={(e) => { e.stopPropagation(); speak(word.word); }}
              className="text-gray-400 hover:text-primary-600 transition-colors flex-shrink-0"
              title="Pronounce"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072M12 6a7 7 0 010 12M8 9l3-3v12l-3-3H5a1 1 0 01-1-1v-4a1 1 0 011-1h3z" />
              </svg>
            </button>
          )}
        </span>
      }
    >
      {/* Examples Section */}
      <div className="mb-6">
        <ul className="space-y-3">
          {word.examples.map((example, index) => (
            <li key={index} className="flex items-start gap-2">
              <span className="text-gray-400 mt-1">•</span>
              <p className="text-gray-700 text-base break-words">
                <HighlightedText text={example.text} />
              </p>
            </li>
          ))}
        </ul>
      </div>

      {/* Translation Section (conditional) - moved to bottom */}
      {word.translation && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">
            Translation {word.dateAdded && `(added on ${formatDate(word.dateAdded)})`}
          </h4>
          <p className="text-base text-gray-900 italic break-words">{word.translation.text}</p>
        </div>
      )}

      {/* Footer with Close button - centered */}
      <div className="flex justify-center pt-4 mt-4">
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};
